var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadStl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4218 2L11.9479 0L8.47395 2H3C1.89543 2 1 2.89543 1 4V21C1 22.1046 1.89543 23 3 23H8.5L6.50003 21H3V4.00003H5V12L11 15.4543V20.17L8.41 17.59L7 19L12 24L17 19L15.59 17.59L13 20.17V15.3943L18.8958 12V4.00003H21V18L16 23H18C18.5304 23 19.2107 22.7893 19.5858 22.4142L22.4142 19.5858C22.7893 19.2107 23 18.5304 23 18V4C23 2.89543 22.1046 2 21 2H15.4218ZM13 13.1315L16.9107 10.8486V6.2531L13 8.56576V13.1315ZM11 8.56576L6.98511 6.2531V10.8486L11 13.1315V8.56576ZM11.9479 6.84864L8.01737 4.55583L11.9479 2.2928L15.8784 4.55583L11.9479 6.84864Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadStl);
export default __webpack_public_path__ + "static/media/download-stl.eea0c7af.svg";
export { ForwardRef as ReactComponent };